import {InlineLink} from '@primer/react-brand/esm'

import {LocaleSelector} from '../LocaleSelector/LocaleSelector'
import {SocialLinks} from '../SocialLinks/SocialLinks'

import type {LocaleConfig, SocialLink, SubFooterCopy} from '../../marketing-footer.types'

import styles from './SubFooter.module.css'

type Props = {
  subFooter: SubFooterCopy
  legalNavLabel: string
  socialNavLabel: string
  localeOverlayLabel: string
  socialLinks: SocialLink[]
  locale: LocaleConfig
  cookieConsentEnabled: boolean
}

export function SubFooter(props: Props) {
  const {subFooter, legalNavLabel, socialNavLabel, localeOverlayLabel, socialLinks, locale, cookieConsentEnabled} =
    props
  const {copyrightLabel, copyrightYear, legalLinks, cookieConsentItems} = subFooter

  const visibleCookieItems = cookieConsentEnabled ? (cookieConsentItems ?? []) : []

  return (
    <div className={styles.bar}>
      <div className={styles.container}>
        <nav aria-label={legalNavLabel} className={styles.legal}>
          <ul className={styles.legalList}>
            <li className={styles.copyright}>
              <time dateTime={String(copyrightYear)}>{copyrightLabel}</time>
            </li>

            {legalLinks.map(link => (
              <li key={`${link.href}-${link.label}`}>
                <InlineLink href={link.href}>{link.label}</InlineLink>
              </li>
            ))}

            {visibleCookieItems.map(item => (
              <li key={item.analyticsAction}>
                {/*
                 * `cookie-consent-link` is a Catalyst custom element shipped by the dotcom asset
                 * pipeline. It hydrates this button to open the OneTrust consent management UI on
                 * click. The intrinsic element is declared in `jsx-elements.d.ts`.
                 */}
                <cookie-consent-link>
                  <button
                    type="button"
                    className={styles.cookieButton}
                    data-action="click:cookie-consent-link#showConsentManagement"
                    data-analytics-event={JSON.stringify({
                      location: 'footer',
                      tag: 'link',
                      action: item.analyticsAction,
                      context: 'subfooter',
                    })}
                  >
                    {item.label}
                  </button>
                </cookie-consent-link>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.socialAndLocale}>
          <nav aria-label={socialNavLabel}>
            <SocialLinks socialLinks={socialLinks} />
          </nav>

          <LocaleSelector locale={locale} overlayLabel={localeOverlayLabel} />
        </div>
      </div>
    </div>
  )
}
